import React, { useState } from "react";
import { ScrollView, View, Text, StyleSheet, SafeAreaView, TouchableOpacity, Animated, Pressable } from "react-native";
import { FeaturedEvent, ActivityFeed, QuickAccess, Announcements, Featured } from "./components";
import { useTheme } from "../../context/ThemeContext";
import { useDesign } from "../../context/DesignContext";
import { useContent } from "../../context/ContentContext";
import { mockFeedData } from "./mockData";
import { Ionicons } from "@expo/vector-icons";
import { withComponentEditor } from "../BaseComponent";
const componentType = "feedPage";
const UnderConstruction = () => {
	const styles = useStyles();

	return (
		<View style={styles.underConstruction}>
			<Text style={styles.underConstructionTitle}>Under Construction</Text>
			<Text style={styles.underConstructionText}>We're working on making this section even better. Check back soon!</Text>
		</View>
	);
};

const FloatingActionButton = ({ onComponentSelect }) => {
	const [isOpen, setIsOpen] = useState(false);
	const theme = useTheme();
	const { fetchDesign } = useDesign();
	const { fetchContent } = useContent();
	const styles = useStyles();
	const componentType = "quickAccess";
	const design = fetchDesign(componentType) || {};
	const content = fetchContent(componentType) || {};
	// Define menu items for the FAB
	const menuItems = [
		{
			label: content.posts.label,
			icon: content.posts.icon,
			onPress: () => {
				console.log("Post pressed");
				// Handle post action
			},
		},
		{
			label: content.featuredAssets.label,
			icon: content.featuredAssets.icon,
			onPress: () => {
				console.log("Create Feature pressed");
				// Handle create feature action
			},
		},
		{
			label: content.createAssets.label,
			icon: content.createAssets.icon,
			onPress: () => {
				console.log("Create Product pressed");
				// Handle create product action
			},
		},
	];
	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};
	const handlePressItem = (onPress) => {
		if (typeof onPress === "function") {
			onPress();
		}
		setIsOpen(false);
	};

	const handlePress = () => {
		if (onComponentSelect) {
			onComponentSelect({
				componentType,
				sections: [
					{
						id: "general",
						title: "General Configuration",
						properties: ["enabled"],
					},
					{
						id: "posts",
						title: "Posts Configuration",
						properties: ["posts.whoCanCreate", "posts.whoCanView", "posts.label", "posts.icon"],
					},
					{
						id: "featuredAssets",
						title: "Featured Assets Configuration",
						properties: ["featuredAssets.enabled", "featuredAssets.whoCanCreate", "featuredAssets.label", "featuredAssets.icon"],
					},
					{
						id: "createAssets",
						title: "Create Assets Configuration",
						properties: ["createAssets.enabled", "createAssets.whoCanCreate", "createAssets.whoCanView", "createAssets.label", "createAssets.icon"],
					},
				],
				properties: {
					// General Configuration
					enabled: {
						store: "content",
						type: "boolean",
						label: "Enable Quick Access",
						description: "Toggle visibility of Quick Access menu",
					},
					// Posts Configuration
					"posts.whoCanCreate": {
						store: "content",
						type: "dropdown",
						label: "Who Can Create Posts",
						description: "User roles who can create posts",
						options: [
							{ label: "All Users", group: "users" },
							{ label: "Admins", group: "admins" },
							{ label: "Mods", group: "mods" },
							{ label: "Subscribers", group: "subscribers" },
						],
					},
					"posts.whoCanView": {
						store: "content",
						type: "dropdown",
						label: "Who Can View Posts",
						description: "Who can view posts",
						options: [
							{ label: "All", group: "all" },
							{ label: "Followers", group: "followers" },
							{ label: "Mutuals", group: "mutuals" },
						],
					},
					"posts.icon": {
						store: "content",
						type: "icon",
						label: "Post Icon",
						description: "Icon for post button",
					},
					"posts.label": {
						store: "content",
						type: "text",
						label: "Post Label",
						description: "Label for post button",
					},
					// Featured Assets Configuration
					"featuredAssets.enabled": {
						store: "content",
						type: "boolean",
						label: "Enable Featured Assets",
						description: "Toggle visibility of featured assets option",
					},
					"featuredAssets.whoCanCreate": {
						store: "content",
						type: "dropdown",
						label: "Who Can Create Featured Assets",
						description: "User roles who can create featured assets",
						options: [
							{ label: "All Users", group: "users" },
							{ label: "Admins", group: "admins" },
							{ label: "Mods", group: "mods" },
							{ label: "Subscribers", group: "subscribers" },
						],
					},
					"featuredAssets.label": {
						store: "content",
						type: "text",
						label: "Featured Assets Label",
						description: "Label for featured assets option",
					},
					"featuredAssets.icon": {
						store: "content",
						type: "icon",
						label: "Featured Assets Icon",
						description: "Icon for featured assets option",
					},

					// Create Assets Configuration
					"createAssets.enabled": {
						store: "content",
						type: "boolean",
						label: "Enable Create Assets",
						description: "Toggle visibility of create assets option",
					},
					"createAssets.whoCanCreate": {
						store: "content",
						type: "dropdown",
						label: "Who Can Create Assets",
						description: "User roles who can create assets",
						options: [
							{ label: "All Users", group: "users" },
							{ label: "Admins", group: "admins" },
							{ label: "Mods", group: "mods" },
							{ label: "Subscribers", group: "subscribers" },
						],
					},
					"createAssets.whoCanView": {
						store: "content",
						type: "dropdown",
						label: "Who Can View Created Assets",
						description: "Who can view created assets",
						options: [
							{ label: "All", group: "all" },
							{ label: "Followers", group: "followers" },
							{ label: "Mutuals", group: "mutuals" },
						],
					},
					"createAssets.label": {
						store: "content",
						type: "text",
						label: "Create Assets Label",
						description: "Label for create assets option",
					},
					"createAssets.icon": {
						store: "content",
						type: "icon",
						label: "Create Assets Icon",
						description: "Icon for create assets option",
					},
				},
			});
		}
	};

	return (
		<View style={styles.fabContainer}>
			{isOpen && menuItems.length > 0 && (
				<View style={styles.fabMenu}>
					{menuItems.map((item, index) => (
						<TouchableOpacity key={`fab-item-${index}`} style={styles.fabItem} onPress={() => handlePressItem(item.onPress)}>
							<View style={styles.fabItemContent}>
								<Text style={styles.fabItemText}>{item.label}</Text>
								<Ionicons name={item.icon} size={24} color={theme.colors.primary} />
							</View>
						</TouchableOpacity>
					))}
				</View>
			)}

			<TouchableOpacity
				style={styles.fab}
				onPress={() => {
					if (isOpen) {
						toggleMenu();
					} else if (onComponentSelect) {
						handlePress();
					}
				}}
				activeOpacity={0.9}
				onLongPress={toggleMenu}>
				<Ionicons name={isOpen ? "close" : "add"} size={26} color={theme.colors.primary} />
			</TouchableOpacity>
		</View>
	);
};

const FeedPage = ({ content = {}, onComponentSelect }) => {
	const theme = useTheme();
	const styles = useStyles();

	const { fetchContent, contentSnapshot } = useContent();
	const pageContent = fetchContent(componentType) || {};
	// Use mock data if no content is provided
	const mergedContent = content.sections && content.sections.length > 0 ? content : mockFeedData;
	const handleFeedEditor = () => {
		if (onComponentSelect) {
			onComponentSelect({
				componentType,
				sections: [
					{
						id: "general",
						title: "General Settings",
						properties: ["pageTitle", "pageIcon"],
					},
				],
				properties: {
					// General Settings
					pageTitle: {
						store: "content",
						type: "text",
						label: "Page Title",
						description: "The title of what your product page will be about. (e.g. Products, Books..., etc.)",
						value: "Products",
					},
					pageIcon: {
						store: "content",
						type: "icon",
						label: "Page Icon",
						description: "The icon of what your product page will be about. (e.g. Products, Books..., etc.)",
					},
				},
			});
		}
	};
	const renderEmptyState = () => (
		<View style={styles.emptyState}>
			<Text style={styles.emptyStateText}>Add components from the Quick Add menu to build your feed page</Text>
		</View>
	);

	if (!mergedContent.sections || mergedContent.sections.length === 0) {
		return (
			<SafeAreaView style={styles.container}>
				<Pressable style={styles.header} onPress={handleFeedEditor}>
					<Text style={styles.title}>{pageContent.pageTitle}</Text>
				</Pressable>
				<ScrollView style={styles.content}>{renderEmptyState()}</ScrollView>
				<FloatingActionButton onComponentSelect={onComponentSelect} />
			</SafeAreaView>
		);
	}

	const renderComponent = (section) => {
		const props = {
			content: section.content,
			id: section.id,
			type: section.type,
		};

		switch (section.type) {
			case "featured":
				return <Featured {...props} />;
			case "events":
				return <FeaturedEvent {...props} />;
			case "quickAccess":
				return <QuickAccess {...props} />;
			case "activity":
				return <ActivityFeed {...props} />;
			case "announcements":
				return <Announcements {...props} />;
			default:
				return null;
		}
	};

	return (
		<SafeAreaView style={styles.container}>
			<Pressable style={styles.header} onPress={handleFeedEditor}>
				<Text style={styles.title}>{pageContent.pageTitle}</Text>
			</Pressable>
			<ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
				{mergedContent.sections.map((section) => (
					<React.Fragment key={section.id}>{renderComponent(section)}</React.Fragment>
				))}
			</ScrollView>
			<FloatingActionButton onComponentSelect={onComponentSelect} />
		</SafeAreaView>
	);
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		container: {
			flex: 1,
			backgroundColor: theme.colors.systemBackground.primary,
		},
		header: {
			padding: theme.spacing.md,
			backgroundColor: theme.colors.systemBackground.primary,
			borderBottomWidth: 1,
			borderBottomColor: theme.colors.separator,
		},
		title: {
			...theme.typography.title1,
			color: theme.colors.text,
			marginBottom: theme.spacing.sm,
		},
		content: {
			flex: 1,
			padding: theme.spacing.lg,
			backgroundColor: theme.colors.systemBackground.secondary,
		},
		emptyState: {
			flex: 1,
			justifyContent: "center",
			alignItems: "center",
			minHeight: 300,
			padding: theme.spacing.xl,
		},
		emptyStateText: {
			color: theme.colors.textSecondary,
			textAlign: "center",
			...theme.typography.body,
		},
		underConstruction: {
			backgroundColor: theme.colors.systemBackground.primary,
			borderRadius: theme.borderRadius.md,
			padding: theme.spacing.xl,
			marginBottom: theme.spacing.lg,
			alignItems: "center",
			justifyContent: "center",
			borderWidth: 1,
			borderColor: theme.colors.separator,
			minHeight: 200,
		},
		underConstructionTitle: {
			...theme.typography.title2,
			color: theme.colors.text,
			marginBottom: theme.spacing.md,
			textAlign: "center",
		},
		underConstructionText: {
			...theme.typography.body,
			color: theme.colors.textSecondary,
			textAlign: "center",
		},
		fabContainer: {
			position: "absolute",
			bottom: 30,
			right: 24,
			alignItems: "flex-end",
		},
		fab: {
			backgroundColor: "#ffffff",
			width: 60,
			height: 60,
			borderRadius: 16,
			justifyContent: "center",
			alignItems: "center",
			shadowColor: "#000",
			shadowOffset: { width: 0, height: 3 },
			shadowOpacity: 0.2,
			shadowRadius: 6,
			elevation: 8,
			zIndex: 1,
		},
		fabMenu: {
			marginBottom: 16,
			alignItems: "flex-end",
		},
		fabItem: {
			marginBottom: 12,
			paddingLeft: 10,
		},
		fabItemContent: {
			backgroundColor: "#ffffff",
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "flex-end",
			paddingVertical: 12,
			paddingLeft: 16,
			paddingRight: 12,
			borderRadius: 12,
			shadowColor: "#000",
			shadowOffset: { width: 0, height: 2 },
			shadowOpacity: 0.15,
			shadowRadius: 3,
			elevation: 3,
		},
		fabItemText: {
			color: theme.colors.text,
			fontWeight: "600",
			marginRight: 12,
			fontSize: 16,
		},
	});
};

// Wrapper component to provide context and theme
const FeedPageWrapper = (props) => {
	const theme = useTheme();
	const WrappedFeedPage = withComponentEditor(FeedPage);

	return <WrappedFeedPage {...props} theme={theme} />;
};

export default FeedPageWrapper;
